import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-search-tasks',
  templateUrl: './search-tasks.component.html',
  styleUrls: ['./search-tasks.component.css']
})
export class SearchTasksComponent implements OnInit {

  title: string;
  subtitle: string;

  constructor(private titleService: Title) { }

  ngOnInit() {
    if (this.titleService.getTitle().includes(" - ")) {
      this.titleService.setTitle(this.titleService.getTitle().split(" - ")[1]);
    }

    this.title = 'Tareas';
    this.subtitle = 'Permite manejar errores, tanto de forma individualizada como masiva';
  }

}
